module.exports = __webpack_public_path__ + "static/media/upload_white.d015b59e.svg";